import React, { Component } from "react"
import { Button, FormControl, InputGroup, Spinner, Table } from "react-bootstrap"
import { connect } from "react-redux"
import LDSRipple from "src/components/common/LDS/LDSRipple/LDSRipple"
import Loader from "src/components/common/Loader"
import { AppState } from "src/store"
import notificationStore from "src/utilities/Notifications/notificationStore"
import NotificationTypes from "src/utilities/Notifications/Types/NotificationTypes"
import View from "src/utilities/Notifications/View/View"
import reggie from "src/utilities/Reggie"
import dayjs from "dayjs"
import "./NotificationManagement.css"

interface Props {
    userId: string | number
}

interface State {
    notificationsState: any
}

class NotificationManagement extends Component<Props, State>{

    history: Array<number> = [-Infinity]

    state = {
        notificationsState: notificationStore.state,
    }

    componentDidMount() {
        //@ts-ignore
        notificationStore.stateWebWorker.addEventListener("message", (event: { data: any }) => {
            this.setState({ notificationsState: event.data })
        })
        this.clearFilters()
    }

    componentWillUnmount() {
        this.clearFilters()
    }

    showOrHideRowControls = (id: number, show: boolean, force?: boolean) => {
        this.killStragglers(id)
        if (notificationStore.state.rowMenuId < 0 || force) {
            let elem = document.getElementById(`notification-management-row-controls-${id}`)
            const display = show ? "block" : "none"
            if (elem) {
                elem.style.display = display
            }
        }
        this.history.push(id)
    }

    killStragglers = (id: number) => {
        for (let i = 0; i < this.history.length; i++) {
            let elem = document.getElementById(`notification-management-row-controls-${id}`)
            if (elem) {
                elem.style.display = "none"
            }
            this.history.splice(this.history.indexOf(id), id)
        }
    }

    handleSingleUpdate = (notification: NotificationTypes, action: string) => {
        this.showOrHideRowControls(notification.id, false, true)
        notificationStore.addOrUpdateNotification([notification], action)
    }

    clearFilters = () => {
        notificationStore.setView(0)
        notificationStore.debounce({ target: { value: "" } })
    }

    filterButton = (item: any, index: number) => {
        const count = notificationStore.countNotifications(notificationStore.state.notifications, item.triggers)
        return (
            <div className={`NotificationManagementControlsLeftFiltersItemChecked-${item.active} NotificationManagementControlsLeftFiltersItem${count === 0 ? "Hide" : "Show"}`}>
                <div className="NotificationManagementControlsLeftFiltersItemButton" onClick={() => notificationStore.setView(index)}>
                    <span>{`${item.title} ${count}`}</span>
                </div>
            </div>
        )
    }

    setPointerColor = (bg: string) => {
        let elem = document.getElementById("notification-management-controls-left-batch-operations-pointer-arrow")
        if (elem) {
            elem.style.color = bg
        }
    }


    render() {

        const props = this.props
        const state = this.state
        const tableItems = notificationStore.tableItems
        const viewTypes = notificationStore.viewTypes
        const notifications = notificationStore.handleViewTypeFilter()
        const checkedList = state.notificationsState.checkedList
        const totalChecked = checkedList.length
        const operations = notificationStore.operations
        const busy = state.notificationsState.busy
        const canBatch = state.notificationsState.view.canBatch

        // console.log("NotificationManagement checkedList", checkedList)
        // console.log("NotificationManagement state", state)

        return (
            <div id="notification-management" className="NotificationManagement main-content col-sm">
                {state.notificationsState.notificationsCopy.length > 0 && <div className="NotificationManagementHasNotifications">
                    <div className="NotificationManagementControls">
                        <div className="NotificationManagementControlsLeft">
                            <div className="NotificationManagementControlsLeftSearch">
                                <div className="NotificationManagementControlsLeftSearchInput">
                                    <FormControl placeholder={"Search"} onChange={notificationStore.debounce} value={state.notificationsState.searchTerm || ""} />
                                </div>
                            </div>
                            {totalChecked === 0 && <div className="NotificationManagementControlsLeftFilters">
                                {viewTypes.map((item, i: number) =>
                                    <div className="NotificationManagementControlsLeftFiltersItem" key={`notification-management-controls-left-filters-item-${i}`}>
                                        {this.filterButton(item, i)}
                                    </div>)}
                            </div>}
                            {totalChecked > 0 && <div className="NotificationManagementControlsLeftBatchOperations">
                                <div className="NotificationManagementControlsLeftBatchOperationsPointer">
                                    <p>{totalChecked}</p>
                                    <span id="notification-management-controls-left-batch-operations-pointer-arrow" className="material-icons">double_arrow</span>
                                </div>
                                {operations.map((item, i: number) =>
                                    <div className="NotificationManagementControlsLeftBatchOperationsItem" key={`notification-management-controls-left-batch-operations-item-${i}`}
                                        onMouseEnter={() => this.setPointerColor(item.bg)}
                                        onMouseLeave={() => this.setPointerColor("#000000")}
                                        onClick={() => notificationStore.addOrUpdateNotification(checkedList, item.operation, true)}>
                                        <Button variant={item.variant}>{item.title}</Button>
                                    </div>)}
                            </div>}
                            {busy && <div className="NotificationManagementControlsLeftStoreBusy">
                                <Spinner id="notification-management-controls-left-store-busy" animation="border" />
                            </div>}
                        </div>
                        <div className="NotificationManagementControlsRight">
                            {/*put something here later maybe*/}
                        </div>
                    </div>
                    <div className="NotificationManagementTable">
                        <Table striped bordered hover>
                            <thead>
                                <tr id="notification-management-table-header">
                                    {tableItems.map((item, i) =>
                                        <th key={`notification-management-table-header-th-${i}`}>
                                            <div className="NotificationManagementHeaderItem">
                                                {i === 0 && canBatch && <div className="NotificationManagementHeaderItemLeftControls">
                                                    <div className="NotificationManagementHeaderItemLeftControlsRadioWrapper">
                                                        <InputGroup>
                                                            <InputGroup.Checkbox checked={notificationStore.state.allChecked} onChange={() => notificationStore.checkOrUncheckAll(notificationStore.state.allChecked ? false : true)} />
                                                        </InputGroup>
                                                    </div>
                                                </div>}
                                                <div className="NotificationManagementHeaderItemText">
                                                    {item.title}
                                                </div>
                                            </div>
                                        </th>)}
                                </tr>
                            </thead>
                            <tbody>
                                {notifications.map((notification, i: number) =>
                                    <tr key={`notification-management-table-tr-${i}`}>
                                        {tableItems.map((item, i) =>
                                            <td key={`notification-management-table-td-${i}`}>
                                                <div className="NotificationManagementTableItem"
                                                    onMouseEnter={() => this.showOrHideRowControls(notification.id, true)}
                                                    onMouseLeave={() => this.showOrHideRowControls(notification.id, false)}
                                                >
                                                    {i === 0 && <div className="NotificationManagementTableItemLeftControls">
                                                        <div className={`NotificationManagementTableItemLeftControlsStatusMarker NotificationManagementTableItemLeftControlsStatusMarker-${notification.notificationState}`}></div>
                                                        <div className="NotificationManagementTableItemLeftControlsRadioWrapper">
                                                            {notificationStore.canCheck(notification) && <InputGroup>
                                                                <InputGroup.Checkbox checked={notification.checked || false} onChange={() => notificationStore.setChecked(notification)} />
                                                            </InputGroup>}
                                                            {!notificationStore.canCheck(notification) && <div className={`NotificationManagementTableItemLeftControlsTaskMarker ${notification.completedDateUtc ? "NotificationManagementTableItemLeftControlsTaskMarkerFinished" : "NotificationManagementTableItemLeftControlsTaskMarkerNotFinished"}`}>
                                                                {notification.completedDateUtc && <span className="material-icons">add_task</span>}
                                                                {!notification.completedDateUtc && <LDSRipple />}
                                                            </div>}
                                                        </div>
                                                    </div>}
                                                    <div className="NotificationManagementTableItemText" onClick={() => notificationStore.setOpenNotification(notification)}>
                                                        {/*@ts-ignore*/}
                                                        {!item.isDate ? ((item.key === "text" && notification.completedDateUtc ? <p className="NotificationManagementTableItemCompletedFormTaskTD">{`Completed ${dayjs(notification.completedDateUtc).utc("z").local().utcOffset(notificationStore.timeZoneOffset).format(notificationStore.timeFormat)}`}</p> : reggie.deKebab(notification[item.key]))) : (item.key === "dueDateUtc") ? (notification[item.key] ? dayjs(notification[item.key]).format(notificationStore.timeFormat) : "-") : notification[item.key] ? dayjs(notification[item.key]).utc("z").local().utcOffset(notificationStore.timeZoneOffset).format(notificationStore.timeFormat) : "-"}
                                                    </div>
                                                    {notificationStore.canCheck(notification) && i === (tableItems.length - 1) && <div id={`notification-management-row-controls-${notification.id}`} className="NotificationManagementTableItemRightControls"
                                                        onMouseEnter={() => this.showOrHideRowControls(notification.id, true)}
                                                        onMouseLeave={() => this.showOrHideRowControls(notification.id, false)}
                                                    >
                                                        <span onClick={() => notificationStore.manageState([{ key: "rowMenuId", value: notificationStore.state.rowMenuId < 0 ? notification.id : -1 }])}>...</span>
                                                    </div>}
                                                </div>
                                                {state.notificationsState.rowMenuId === notification.id && !notificationStore.state.notificationMenuOpen && <div className="NotificationActionMenu" onMouseLeave={() => notificationStore.manageState([{ key: "rowMenuId", value: -1 }])}>
                                                    {notification.notificationState !== "read" && <div className="NotificationActionMenuItem" onClick={() => this.handleSingleUpdate(notification, "read")}>
                                                        <p>Mark Read</p>
                                                    </div>}
                                                    {notification.notificationState !== "new" && <div className="NotificationActionMenuItem" onClick={() => this.handleSingleUpdate(notification, "new")}>
                                                        <p>Mark Unread</p>
                                                    </div>}
                                                    {notification.notificationState !== "todo" && <div className="NotificationActionMenuItem" onClick={() => this.handleSingleUpdate(notification, "todo")}>
                                                        <p>Mark Todo</p>
                                                    </div>}
                                                    {notification.notificationState !== "deleted" && <div className="NotificationActionMenuItem" onClick={() => this.handleSingleUpdate(notification, "deleted")}>
                                                        <p>Delete</p>
                                                    </div>}
                                                </div>}
                                            </td>
                                        )}
                                    </tr>)}
                            </tbody>
                        </Table>
                    </div>
                    {state.notificationsState.openManagementNotification && <View
                        notification={state.notificationsState.openManagementNotification}
                        userId={props.userId}
                    />}
                </div>}
                {
                    state.notificationsState.notificationsCopy.length === 0 && busy && <div className="NotificationManagementLoadingNotifications">
                        <span className="material-icons">notifications</span>
                        <p>Loading notifications</p>
                        <Loader title="" />
                    </div>
                }
                {
                    state.notificationsState.notificationsCopy.length === 0 && !busy && <div className="NotificationManagementNoNotifications">
                        <span className="material-icons">notifications</span>
                        <span className="material-icons">do_not_disturb_alt</span>
                        <p>No notifications yet...</p>
                    </div>
                }
                {
                    notifications.length === 0 && state.notificationsState.searchTerm.length > 0 && !busy && <div className="NotificationManagementNoNotificationsFound">
                        <span className="NotificationManagementNoNotificationsFoundErrEmoji">{`(>_<)`}</span>
                        <p>{`No notifications found for "${state.notificationsState.searchTerm}"`}</p>
                        <Button variant="secondary" onClick={() => this.clearFilters()}>Reset your filters and try again?</Button>
                    </div>
                }
            </div >
        )
    }
}

const mapStateToProps = (state: AppState) => ({
    userId: state.user.userId
})

export default connect(mapStateToProps)(NotificationManagement)